/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface ResultCULGridListPayload {
    pageNo?: number;
    pageSize?: number;
}

export interface ResultCULGridListItem {
    compulsoryId: string;
    careerTitle: string;
    aplType: string;
    appCancelOkFlg: boolean;
    applyDate: string;
    applyUserId: string;
    approvalDate: string;
    approvalUserId: string;
    careerId: string;
    complDate: string;
    compulsoryCssClass: string;
    credit: string;
    lecCancelOkFlg: boolean;
    organizer: string;
    status: string;
    statusId: string;
    target: string;
    displayStartDateTime: string;
    displayEndDateTime: string;
}

export interface ResultCULGridListResponse {
    resultCULGridList: ResultCULGridListItem[];
    pagerTotalDataCount?: number;
}

class ResultCULGridListService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "result/cULGridList");
    }

    public async fetch(payload?: ResultCULGridListPayload): Promise<ResultCULGridListResponse> {
        return super.postWithPromise(payload).then((json: any) => json as ResultCULGridListResponse);
    }

    /**
     * 結果が1ページに収まらない場合に繰り返し取得して全件取得する
     * @param payload 
     * @returns 
     */
    public async fetchAll(payload?: { pageSize?: number }): Promise<ResultCULGridListResponse> {
        const pageSize = payload?.pageSize ?? 9999;
        const responseStack: ResultCULGridListResponse["resultCULGridList"][] = [];
        for (let pageNo = 1; ; ++pageNo) {
            try {
                const result: unknown = await this.fetch({ pageNo, pageSize });

                if (!result ||
                    typeof result !== 'object' ||
                    !('resultCULGridList' in result) ||
                    !Array.isArray(result.resultCULGridList) ||
                    result.resultCULGridList.every(x => typeof x !== 'object')
                ) {
                    console.error("failed to fetch result/cULGridList - result:", result);
                    break;
                }

                // 要素ごとのバリデーションは省略
                const resultGridList = result.resultCULGridList as ResultCULGridListItem[];

                // 0件の時はpushせずにbreakしたほうが早いがコードが微妙に複雑になるので省略
                responseStack.push(resultGridList);

                if (resultGridList.length < pageSize) {
                    break; // 確実に次のページがない
                }
            } catch (e) {
                console.error("failed to fetch result/cULGridList", e);
                break;
            }
        }
        return { resultCULGridList: responseStack.flatMap(x => x) };
    }
}

export default ResultCULGridListService;
